import { useProfiles } from "@entities/profile/api/useProfiles";
import { useActiveProfile } from "@shared/context/ActiveProfileContext";

// Активный профиль члена семьи + производные флаги.
// activeProfile === null — контекст владельца аккаунта (родитель/сам студент без выбранного профиля).
// isChildMode === true — активен детский профиль: запрещены чат, бронирование, покупки/пакеты.
export const useActiveProfileInfo = () => {
	const { activeProfile: storedProfile, setActiveProfile, clearActiveProfile } = useActiveProfile();
	const { data: profiles = [] } = useProfiles();

	// Список профилей доступен только владельцу; в детском режиме берём снапшот из localStorage
	const activeProfile = profiles.find((profile) => profile.id === storedProfile?.id) ?? storedProfile;

	return {
		profiles,
		activeProfile,
		activeProfileId: activeProfile?.id ?? null,
		isChildMode: Boolean(activeProfile?.is_child),
		setActiveProfile,
		clearActiveProfile,
	};
};
